import React, { useEffect, useState } from 'react';
import firebaseGetImageUrl from '../../helpers/firebaseGetImageUrl';
import EvaluateSubmission from '../../services/evaluate-submission';
import ProgressCircle from '../ProgressCircle';
import styles from './style.module.css';

export default function ProductSubmission({
  pid,
  category,
  subCategory,
  description,
  photos = [],
  price,
  discount,
  size,
  brand,
  color,
  colorName,
  refreshContent,
  prod
}) {
  const [_photos, setPhotos] = useState([]);
  const [loading_allow, setLoading_allow] = useState(false);
  const [loading_deny, setLoading_deny] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  async function loadFullPhotos() {
    const output = [];
    for (let i = 0; i < photos.length; i++) {
      const photo = photos[i];
      const url = await firebaseGetImageUrl(photo);
      output.push(url);
    }
    setPhotos(output);
  }

  async function Allow() {
    if (loading_allow || loading_deny)
      return;
    setLoading_allow(true);
    await EvaluateSubmission(pid, "allow", "", refreshContent, () => {
      console.error("Failed to allow the product");
    });
    setLoading_allow(false);
  }

  async function Deny() {
    if (loading_allow || loading_deny)
      return;
    setLoading_deny(true);
    await EvaluateSubmission(pid, "deny", "", refreshContent, () => {
      console.error("Failed to deny the product");
    });
    setLoading_deny(false);
  }

  const finalPrice = () => {
    return prod.discount ? (prod.price - (prod.discount / 100) * prod.price) : prod.price;
  }

  useEffect(() => {
    loadFullPhotos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={'card container mt-2 p-3 shadow'}>
      {/* Title */}
      <p className={styles.category}>{category}</p>
      {/* Sub category */}
      <p className={styles.subCategory}>{subCategory}</p>
      {/* Brand */}
      <p className={styles.brand}>{brand}</p>
      <a href={`/p/${prod.uid}`} className={styles.brand}>Profile</a>

      <div className={'card p-2 mb-3'}>
        {/* Description */}
        <p className={styles.description}>{description}</p>
        {/* Images */}
        <div className={styles.imgWrapper}>
          {_photos.map((photo, index) => {
            return (<img key={index} onClick={() => { window.open(photo, '_blank'); }}
              className={styles.img} alt={""} src={photo} />);
          })}
        </div>
      </div>
      {/* Price */}
      <p className={styles.price}>საწყისი ფასი: {price} ₾</p>

      {prod.discount !== undefined && <p className={styles.price}>ფასდაკლება: {prod.discount}%</p>}
      {/* Discount */}
      <p className={styles.price}>საბოლოო ფასი: {finalPrice()} ₾</p>
      {/* Color */}
      <p style={{ color: '#000', margin: 0 }}>{colorName}</p>
      <div className={styles.colorWrapper} style={{ backgroundColor: color }} />
      {/* Size */}
      <div className={styles.sizeWrapper}>
        <p style={{ margin: 0 }}>ზომა: {size}</p>
      </div>
      {/* Button */}
      <div className={'row p-3 gap-2'}>
        <button onClick={Allow} className={'btn btn-success col'}>
          {loading_allow && <ProgressCircle />}Allow</button>
        <button onClick={Deny} className={'btn btn-danger col'}>
          {loading_deny && <ProgressCircle />}Don't allow</button>
        <a href={`/edit/private-products/${pid}`} className="btn btn-primary col">Edit</a>
      </div>
    </div>
  );
}
